<template>
	<!-- 底部导航栏 -->
	<footer class="bottom-nav">
		<div class="footer-content">
			<div class="footer-logo">
				<img class="footer-logo-img" src="../assets/logo.png" alt="岱屿画境">
				<div class="footer-logo-text">岱屿画境，是连接AI艺术创作者与爱好者的数字家园。创作者可以自由展示、交易作品；爱好者能邂逅独具特色的AI艺术，互动交流。让我们共筑一个自由温暖、生生不息的AI艺术社区。
				</div>
			</div>
			<div class="footer-links-container">
				<div class="footer-links-title">
					帮助中心
				</div>
				<div class="footer-links">
					<router-link to="/about">关于平台</router-link>
					<router-link to="/common-problem">常见问题</router-link>
					<div @click="handleAddFeedback">意见反馈</div>
					<router-link to="/agreement">平台用户服务协议</router-link>
				</div>
			</div>
		</div>
		<div class="copyright">
			Copyright © 2025 岱屿画境 浙ICP备2025195505号 <img class="police" src="../assets/Register/police.png"
				alt="" />浙公网安备33010202005149号
		</div>
		<el-dialog class="feedbackDialog" :visible="feedbackPop" append-to-body @close="handleClose">
			<div slot="title">
				<div class="dislogTitle">
					意见反馈
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="" prop="content">
						<div class="contentBox">
							<textarea maxlength="500" v-model="ruleForm.content" placeholder="请输入反馈内容"></textarea>
							<div class="textNum">
								{{ruleForm.content ? ruleForm.content.length : 0}}/ <span>500</span>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="" prop="address">
						<div class="imgList">
							<div class="imgItem" v-for="(item,index) in imgList" :key="index">
								<img class="imgItemImg" :src="item" />
								<img class="delete" @click="imgList.splice(index, 1)"
									src="../assets/Feedback/delete.png" />
							</div>
							<div class="addImgBox" @click="uploadPhoto" v-if="imgList.length != 6">
								<img class="addImg" src="../assets/Feedback/addImg.png" />
								上传图片
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium"
						@click="submitForm('ruleForm')">提交</el-button>
				</div>
			</div>
		</el-dialog>
		<el-upload ref="upload" name="image" action="https://ht.daiyuart.com/api.php/set/Other/upload_img"
			:show-file-list="false" :limit="6" multiple :on-success="handlePhotoSuccess">
		</el-upload>
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'感谢您的反馈，我们将继续努力'"
			@clickOk="sucPop = false" v-if="sucPop" />
	</footer>
</template>

<script>
	import PopToast from '../components/PopToast.vue'
	export default {
		name: 'BottomNavBar',
		components: {
			PopToast,
		},
		data() {
			return {
				ruleForm: {
					content: '',
				},
				rules: {
					content: [{
						required: true,
						message: '请输入反馈内容',
						trigger: 'blur'
					}],
				},
				imgList: [],
				feedbackPop: false,
				sucPop: false
			}
		},
		methods: {
			uploadPhoto() {
				this.$refs.upload.$el.querySelector('input').click();
			},
			handlePhotoSuccess(response) {
				this.imgList.push(response.data)
			},
			handleAddFeedback() {
				if (localStorage.getItem('token')) {
					this.feedbackPop = true
				} else {
					this.$router.push({
						path: '/login',
					})
				}
			},
			handleClose() {
				this.imgList = []
				this.ruleForm.content = ''
				this.feedbackPop = false
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/UserD/feedback_add', {
							banner: this.imgList.join(','),
							content: this.ruleForm.content,
						}).then(res => {
							if (res.code == 1) {
								this.feedbackPop = false
								this.sucPop = true
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	/* 底部导航栏样式 */
	.bottom-nav {
		height: 2.54rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		background: #E4D9C6;
		position: relative;
	}

	.footer-content {
		max-width: 12rem;
		display: flex;
		align-items: center;
	}

	.footer-logo {
		margin-top: .6rem;
		width: 50%;

		&-img {
			width: 1.5rem;
			height: .3rem;
		}

		&-text {
			margin-top: .16rem;
			font-size: .14rem;
			color: #333333;
			line-height: .2rem;
			max-width: 90%;
		}
	}

	.footer-links-container {
		width: 50%;
		margin-top: .6rem;
	}

	.footer-links-title {
		margin-top: .12rem;
		font-weight: 500;
		font-size: .18rem;
		color: #000000;
		line-height: .25rem;
	}

	.footer-links {
		margin-top: .2rem;
		display: flex;
		gap: .4rem;
		margin-bottom: 10px;
	}

	.footer-links a,
	.footer-links div {
		font-size: .16rem;
		color: #333333;
		line-height: .2rem;
		text-decoration: none;
		transition: color 0.3s;
		cursor: pointer;
	}

	.footer-links a:hover {
		color: #6B3503;
	}

	.footer-links div:hover {
		color: #6B3503;
	}

	.copyright {
		position: absolute;
		bottom: 0;
		left: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: .48rem;
		background: #CBBC9D;
		font-size: .12rem;
		color: #333333;
		text-align: center;

		.police {
			margin-left: .12rem;
			margin-right: .04rem;
			width: .14rem;
			height: .14rem;
		}
	}

	.feedbackPop {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.5);
		z-index: 101;

		.centerContent {
			width: 7.4rem;
			background: #FFFFFF;
			border-radius: .12rem;
			padding: .24rem .24rem .32rem;
			position: relative;

			.close {
				position: absolute;
				top: .3rem;
				right: .26rem;
				width: .14rem;
				height: .14rem;
				cursor: pointer;
			}

			.title {
				font-weight: 500;
				font-size: .18rem;
				color: #252525;
				line-height: .26rem;
			}

			.contentBox {
				margin-top: .24rem;
				width: 6.92rem;
				height: 3.25rem;
				background: #FFFFFF;
				border-radius: .04rem;
				border: .01rem solid #EFD8B8;
				padding: .12rem .12rem;
				position: relative;

				textarea {
					width: 100%;
					height: 100%;
					font-size: .14rem;
					padding: 0 0;
					border: none;
				}

				.textNum {
					position: absolute;
					right: .12rem;
					bottom: .12rem;
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: .14rem;
					color: #252525;

					span {
						color: #999999;
					}
				}
			}

			.imgList {
				margin-top: .24rem;
				display: flex;
				flex-wrap: wrap;

				.imgItem {
					margin-right: .16rem;
					display: flex;
					width: .86rem;
					height: .86rem;
					border-radius: .04rem;
					overflow: hidden;
					position: relative;

					.delete {
						position: absolute;
						top: .05rem;
						right: .05rem;
						width: .14rem;
						height: .14rem;
						cursor: pointer;
					}

					.imgItemImg {
						width: .86rem;
						height: .86rem;
						object-fit: cover;
					}
				}

				.addImgBox {
					width: .86rem;
					height: .86rem;
					border-radius: .04rem;
					background: #FFFFFF;
					border: 1px solid #EFD8B8;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					font-weight: 400;
					font-size: .12rem;
					color: #999999;
					cursor: pointer;

					.addImg {
						margin-bottom: .08rem;
						width: .27rem;
						height: .23rem;
					}
				}
			}

			.submit {
				margin: .32rem auto 0;
				width: 1.3rem;
				height: .36rem;
				background: #E29358;
				border-radius: .04rem;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				text-align: center;
				line-height: .36rem;
				cursor: pointer;
			}
		}
	}

	.feedbackDialog {
		::v-deep .el-dialog {
			width: 7.40rem;
			border-radius: .12rem;

			&__headerbtn {
				top: .24rem;
				right: .24rem;
			}

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.el-form {

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							line-height: unset;

							.contentBox {
								width: 6.92rem;
								height: 3.25rem;
								background: #FFFFFF;
								border-radius: .04rem;
								border: .01rem solid #EFD8B8;
								padding: .12rem .12rem;
								position: relative;

								textarea {
									width: 100%;
									height: 100%;
									font-size: .14rem;
									padding: 0 0;
									border: none;
								}

								.textNum {
									position: absolute;
									right: .12rem;
									bottom: .12rem;
									display: flex;
									align-items: center;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;

									span {
										background: #FFFFFF;
										line-height: .2rem;
										color: #999999;
									}
								}
							}

							.imgList {
								display: flex;
								flex-wrap: wrap;

								.imgItem {
									margin-right: .16rem;
									display: flex;
									width: .86rem;
									height: .86rem;
									border-radius: .04rem;
									overflow: hidden;
									position: relative;

									.delete {
										position: absolute;
										top: .05rem;
										right: .05rem;
										width: .14rem;
										height: .14rem;
										cursor: pointer;
									}

									.imgItemImg {
										width: .86rem;
										height: .86rem;
										object-fit: cover;
									}
								}

								.addImgBox {
									width: .86rem;
									height: .86rem;
									border-radius: .04rem;
									background: #FFFFFF;
									border: 1px solid #EFD8B8;
									display: flex;
									flex-direction: column;
									align-items: center;
									justify-content: center;
									font-weight: 400;
									font-size: .12rem;
									color: #999999;
									cursor: pointer;

									.addImg {
										margin-bottom: .08rem;
										width: .27rem;
										height: .23rem;
									}
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: 0 auto;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>